/**
 * design_handoff_auth §5 — neutral inline panel, used for the Google
 * "no account yet" notice (variant="info") and for surfacing card-level API
 * errors that don't map to a single field (variant="error"). Never a toast.
 */
import React from "react";
import classNames from "classnames";
import { Icon } from "../../theme/untitled";
import styles from "./AuthAlert.module.scss";

const ICON_BY_VARIANT = {
  info: "HelpCircle",
  error: "AlertCircle",
};

const AuthAlert = ({ variant = "info", children, className }) => {
  return (
    <div className={classNames(styles.root, styles[`root--${variant}`], className)}>
      <Icon name={ICON_BY_VARIANT[variant]} size={20} className={styles.icon} />
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default AuthAlert;
